import {cx} from "@emotion/css";

import {designColors} from "~/ui";
import {ReactComponent as SvgZoomIn} from "~/assets/svg/zoom-in.svg";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmZoomInIcon: React.FC<IIconBase> = ({id, size = "md", color = designColors.black, className}) => {
  return <SvgZoomIn id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
